import { showErrorToast, showSuccessToast } from "@/utils/toasts";

export const showUrlCopiedNotification = () => {
  showSuccessToast("Url copied to clipboard!");
};

export const showRequestVoiceNotificationSent = () => {
  showSuccessToast(
    "Thank you for your vote! We will add it soon. Please check back a bit later.",
  );
};

export const showRequestVoiceNotificationFailed = () => {
  showErrorToast("Something went wrong! Try again later.");
};

export const showHistoryDeletedNotification = () => {
  showSuccessToast("History file successfully deleted!");
};

export const showFailedToDeleteHistoryFileNotification = () => {
  showSuccessToast("Failed to delete the history file!");
};

export const showBlendedVoiceSuccessfullyDeletedNotification = () => {
  showSuccessToast("The blended voice was successfully deleted!");
};

export const showFailedToDeleteBlendedVoiceNotification = () => {
  showErrorToast("Failed to delete the blended voice!");
};

export const showCustomVoiceSuccessfullyDeletedNotification = () => {
  showSuccessToast("The custom voice was successfully deleted!");
};

export const showFailedToDeleteCustomVoiceNotification = () => {
  showErrorToast("Failed to delete the custom voice!");
};

export const showRequestedFeatureNotificationSent = () => {
  showSuccessToast(
    "We have received your request and will notify you when we add the feature!",
  );
};

export const showVerificationEmailSent = (text: string) => {
  showSuccessToast(text);
};

export const showPurchaseSuccessfulNotification = () => {
  showSuccessToast("Purchase successful.");
};

export const showNotEnoughCreditsError = () => {
  showErrorToast("Not enough credits.");
};

export const showUnknownPurchaseError = () => {
  showErrorToast("Unknown purchase error. Please contact support.");
};

export const showUploadFileForDuetError = () => {
  showErrorToast("Please upload a file to start duets generation");
};

export const showFeedbackSentNotification = () => {
  showSuccessToast("Thanks for your feedback!");
};

export const showRequestApiNotificationSent = () => {
  showSuccessToast(
    "Thank you for your request! We will answer as soon as possible.",
  );
};

export const showRequestApiNotificationError = () => {
  showErrorToast(
    "Your request was not sent! Please contact hi@audiomodify.com",
  );
};

export const showCustomVoiceQualityNowSupportedError = () => {
  showErrorToast("The selected quality is not supported by the current plan");
};

export const showPublicVoicesNotSupportedError = () => {
  showErrorToast("The current plan does not support public voices");
};
